import React from "react";
import HeaderSection from "../common/HeaderSection";
import HeaderParagraph from "../common/HeaderParagraph";
export default function RD() {
  return (
    <section
      id="content"
      className="container clearfix"
      style={{
        padding: "0px",
        outline: "none",
        margin: "0px auto",
        marginBottom: "0px"
      }}
    >
      <HeaderSection title={"Research & Development"}></HeaderSection>
      <div style={{ margin: "0px", padding: "0px", outline: "none" }}>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          Our Research and Development is part of innovative activities to
          create new products and improve existing ones. It is a continuous
          process that involves the development of new technologies, products,
          and services to meet the evolving needs of our customers. Our R&D team
          works closely with various stakeholders to ensure that we are at the
          forefront of technological advancements and can deliver solutions that
          are not only effective but also sustainable.
        </p>
        <HeaderParagraph title={"Innovation"}></HeaderParagraph>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          Innovation is the core of our Research and Development, leading to the
          development of new technologies, products, and solutions to meet
          evolving customer values and new everyday technological improvements,
          needs and challenges.
        </p>
        <HeaderParagraph title={"Impact"}></HeaderParagraph>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          Innovation is the core of our Research and Development, leading to the
          development of new technologies, products, and solutions to meet
          evolving customer values and new everyday technological improvements,
          needs and challenges.
        </p>
        <HeaderParagraph title={"Investment"}></HeaderParagraph>
        <p
          style={{
            margin: "0px",
            padding: "0px",
            outline: "none",
            marginBottom: "20px"
          }}
        >
          We continously invest financially on resources human and
          technological. Investement is associated with risk due to involved
          uncertainties and trying to achieving desired outcomes.
        </p>
      </div>
    </section>
  );
}
